export default {
  hebei: {
    svPay: {
      link: 'https://shop19302141.m.youzan.com/wscgoods/detail/3f0eykazdzppx?step=2'
    },
    svPay_renew: {
      link: 'https://shop19302141.m.youzan.com/wscgoods/detail/3evfi6ns5037p?step=2'
    },
    gvPay: {
      link: 'https://shop19302141.m.youzan.com/wscgoods/detail/1yf5i3dyerqkl?step=2'
    },
    gvPay_renew: {
      link: 'https://shop19302141.m.youzan.com/wscgoods/detail/3nqiklho86qx1?step=2'
    },
    zybPay: {
      link:
        'https://wx43cddada7b553cec.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjoiMiIsInJlc291cmNlX3R5cGUiOjIxLCJyZXNvdXJjZV9pZCI6ImdfNWYwNTc3OWM0YzBiOV9HNVg5M01ZYiIsImFwcF9pZCI6ImFwcGRYblFVQ2ROOTUzMiIsInByb2R1Y3RfaWQiOiIifQ'
    },
    popup5Pay: {
      link: 'https://appdXnQUCdN9532.h5.xiaoeknow.com/v1/entity/g_5f05738318b90_wGuaeY35?type=2'
    }
  },
  shanxi: {
    svPay: {
      link:'https://shop40222879.m.youzan.com/wscgoods/detail/3ey0eae38uconr7?scan=1&amp;activity=none&amp;from=kdt&amp;qr=directgoods_3349841821&amp;shopAutoEnter=1'
    },
    svPay_renew: {
      link: 'https://shop40222879.m.youzan.com/wscgoods/detail/2olhrf1yas99zk6?scan=1&amp;activity=none&amp;from=kdt&amp;qr=directgoods_3349842138&amp;shopAutoEnter=1'
    },
    gvPay: {
      link: 'https://shop40222879.m.youzan.com/wscgoods/detail/3f2x2sjztqtafdj?scan=1&activity=none&from=kdt&qr=directgoods_3349833988&shopAutoEnter=1'
    },
    gvPay_renew: {
      link: 'https://shop40222879.m.youzan.com/wscgoods/detail/3nj6svz7bnefbfn?scan=1&amp;activity=none&amp;from=kdt&amp;qr=directgoods_3349916030&amp;shopAutoEnter=1'
    },
    popup5Pay: {
      link:'https://shop40222879.m.youzan.com/wscgoods/detail/3ey0eae38uconr7?scan=1&amp;activity=none&amp;from=kdt&amp;qr=directgoods_3349841821&amp;shopAutoEnter=1'
    }
  },
  rrt: {
    svPay: {
      link:
        'https://shop90421853.m.youzan.com/wscgoods/detail/2oqp0durgoeit?scan=1&activity=none&from=kdt&qr=directgoods_997968368&shopAutoEnter=1'
    },
    svPay_renew: {
      link:
        'https://shop90421853.m.youzan.com/wscgoods/detail/2ovkhhe5ipxit?scan=1&activity=none&from=kdt&qr=directgoods_941152084&shopAutoEnter=1'
    },
    gvPay: {
      link:
        'https://shop90421853.m.youzan.com/wscgoods/detail/3f1xdy6wvhz7p?scan=1&activity=none&from=kdt&qr=directgoods_942065937&shopAutoEnter=1'
    },
    gvPay_renew: {
      link:
        'https://shop90421853.m.youzan.com/wscgoods/detail/276r7j08xw3kl?scan=1&activity=none&from=kdt&qr=directgoods_941155480&shopAutoEnter=1'
    },
    zybPay: {
      link:
        'https://wx43cddada7b553cec.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjoiMiIsInJlc291cmNlX3R5cGUiOjIxLCJyZXNvdXJjZV9pZCI6ImdfNWYwNTc3OWM0YzBiOV9HNVg5M01ZYiIsImFwcF9pZCI6ImFwcGRYblFVQ2ROOTUzMiIsInByb2R1Y3RfaWQiOiIifQ'
    },
    popup5Pay: {
      link: 'https://appdXnQUCdN9532.h5.xiaoeknow.com/v1/entity/g_5f05738318b90_wGuaeY35?type=2'
    }
  }
}
